import React from 'react';
import PropTypes from 'prop-types';
import StepControlButtons from '../UI/StepControlButtons';
import { Translate } from 'react-localize-redux';
import Image from '../../../assets/images/communities-orange-icon.jpg';

export default class IntroductionStep extends React.Component {
	static propTypes = {
		nextStep: PropTypes.func,
		isAutoOpen: PropTypes.bool,
	};

	render() {
		const props = this.props;

		return (
			<div className="wizard-content">
				<h1>
					<Translate id="your_edelweiss_communities" />
				</h1>
				<div className="flex-container">
					<div>
						<div className="communities-description">
							<Translate id="communities_description" />
						</div>
						<div>
							<p>
								<Translate id="users_within_a_community_can" />
							</p>
							<ul className="no-margin">
								<li>
									<span className="bold">
										<Translate id="word_share" />
									</span>
									<span>&nbsp;</span>
									<Translate id="community_wizard_share_reviews" />
								</li>
								<li>
									<span className="bold">
										<Translate id="word_view" />
									</span>
									<span>&nbsp;</span>
									<Translate id="community_wizard_view_reviews" />
								</li>
								<li className="italic">
									<Translate id="community_wizard_and_more" />
								</li>
							</ul>
						</div>
					</div>
					<div id="wizard-intro-image">
						<img src={Image} alt="Communities page" width="150" />
					</div>
				</div>
				<div>
					<Translate id="community_wizard_communities_allow_you_to" />
				</div>
				<div>
					<Translate id="community_wizard_user_instructions" />
				</div>
				<StepControlButtons
					goNext={props.nextStep}
					remindMeLater={props.isAutoOpen ? this.remindMeLater : null}
					doNotShowAgain={
						props.isAutoOpen ? this.doNotShowAgain : null
					}
					cancel={props.isAutoOpen ? null : this.closeWizard}
				/>
			</div>
		);
	}

	closeWizard() {
		var url =
			window.location !== window.parent.location
				? document.referrer
				: document.location.href;
		var data = {
			action: 'wizard::community::close',
		};

		window.parent.postMessage(JSON.stringify(data), url);
	}

	remindMeLater() {
		var url =
			window.location !== window.parent.location
				? document.referrer
				: document.location.href;

		window.parent.postMessage(
			JSON.stringify({ action: 'wizard::community::remind-me-later' }),
			url,
		);
	}

	doNotShowAgain() {
		var url =
			window.location !== window.parent.location
				? document.referrer
				: document.location.href;

		window.parent.postMessage(
			JSON.stringify({
				action: 'wizard::community::do-not-show-me-again',
			}),
			url,
		);
	}
}
